"use client";

import { TextButton } from "../ui/TextButton.js";


export interface CookiePreferencesButtonProps {
    className: string | undefined;
}


export function CookiePreferencesButton({ className }: CookiePreferencesButtonProps) {
    return (
        <TextButton
            className={className}
            onClick={() => {
                if (window.__tcfapi) {
                    window.__tcfapi("displayConsentUi", 2, () => {});
                }
            }}>

            Privacy Settings
        </TextButton>
    );
}
